export const setTokenInfo = "LOGIN/SET_PARSED_TOKEN";
export const tokenInfo = "LOGIN/GET_PARSED_TOKEN";
